import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { ListSelect, OnChangeHandler, OnMultiChangeHandler } from '../formElements';
import { fetchListsQuery, parseListOption } from './ListMembershipSelect.utils';
import { ALL_BUT_DYNAMIC_LIST_TYPES } from './types';

export const fetchAllItemsVariables = {
  search: '',
  filterInfo: { listType: ALL_BUT_DYNAMIC_LIST_TYPES },
  sort: {
    sortBy: 'UpdatedAt',
    sortDirection: SORT_DIRECTIONS.DESCENDING,
  },
};

type SingleSelectProps = {
  onChange: OnChangeHandler;
  id: string;
  value: string;
  isError?: boolean;
  placeholder?: string;
  isReadOnly?: boolean;
  isMulti?: false;
};

type MultiSelectProps = {
  onChange: OnMultiChangeHandler;
  id: string;
  value: string[];
  isError?: boolean;
  placeholder?: string;
  isReadOnly?: boolean;
  isMulti: true;
};

type ListMembershipSelectProps = SingleSelectProps | MultiSelectProps;

export const ListMembershipSelect = (props: ListMembershipSelectProps) => {
  const { isReadOnly, isMulti = false } = props;

  if (isMulti) {
    return (
      <ListSelect
        data-formfieldtype="select"
        data-selectoptiontype="list"
        {...props}
        isMulti={true}
        listType={ALL_BUT_DYNAMIC_LIST_TYPES}
        fetchAllItemsQuery={fetchListsQuery}
        fetchAllItemsVariables={fetchAllItemsVariables}
        parseOption={parseListOption}
        isDisabled={isReadOnly}
        isFullWidth
      />
    );
  }

  return (
    <ListSelect
      data-formfieldtype="select"
      data-selectoptiontype="list"
      {...props}
      isMulti={false}
      listType={ALL_BUT_DYNAMIC_LIST_TYPES}
      fetchAllItemsQuery={fetchListsQuery}
      fetchAllItemsVariables={fetchAllItemsVariables}
      parseOption={parseListOption}
      isDisabled={isReadOnly}
      isFullWidth
    />
  );
};
